import React from "react";
import "./Heading.css";



const Heading = ({ head }) => {
    return (
        <>
            <h1 className="heading comic-neue-bold">{head}</h1>
        </>
    )
}



export default Heading;